// removed by extract-text-webpack-plugin
module.exports = {"columnChooser":"_15YUo","columnChooserTitle":"_1svXF","columnItem":"_1WGr0"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Table/components/Settings.css
// module id = 474
// module chunks = 0